define('cart', ['jquery'], function ($) {
    var _internals = {
        updateWidget: function (data) {
            var cart = $('#cart-widget');
            cart.find('[data-role="cart-qty-holder"]').html(data.total.positions);
            cart.find('[data-role="cart-cost-holder"]').html(data.total.cost);
        },
        performAction: function (action, payload, callback) {
            var url = '/cart/' + action;
            $.ajax({
                dataType: "json",
                contentType: "application/json",
                url: url,
                type: 'POST',
                data: JSON.stringify(payload),
                success: function (data) {
                    if (typeof callback === 'function') {
                        callback(data);
                    }
                    if (data.result === 'success') {
                        _internals.updateWidget(data);
                    }
                }
            });
        }
    };

    return {
        add: function (id, quantity, comment, callback) {
            _internals.performAction('add', {id: id, qty: quantity, comment: comment}, callback);
        },
        update: function (id, quantity, comment, append, callback) {
            _internals.performAction('update', {id: id, qty: quantity, comment: comment, append: append}, callback);
        },
        delete: function (id, callback) {
            _internals.performAction('delete', {id: id}, callback);
        },
        applyCoupon: function (code, callback) {
            _internals.performAction('applyCoupon', {code: code}, callback);
        },
        bindToUI: function () {
            $(document).on('click', '[data-action="add-to-cart"]', function (event) {
                event.preventDefault();
                var $this = $(this);
                var id = $this.data('id');
                _internals.performAction('add', {id: id, qty: 1, comment: ''}, function (data) {
                    if (data.result === 'success') {
                        $this.addClass('hidden').data('in-cart', true);
                        $('a[data-action="go-to-cart"][data-id="' + id + '"]').removeClass('hidden').data('in-cart', true);
                    }
                });
            });

            $(document).on('keyup change', '[data-action="put-to-cart"]', function (event) {
                event.preventDefault();
                var $this = $(this);
                var id = $this.data('id');

                var max = parseInt($this.attr('max'));
                var quantity = $this.val();

                if (quantity > max) {
                    quantity = max;
                    $this.val(quantity);
                }

                if (quantity > 0) {
                    _internals.performAction('add', {id: id, qty: quantity, comment: ''});
                } else {
                    _internals.performAction('delete', {id: id});
                }
            });
        }
    };
});